<script>
  import ListItem from "../ListItem.svelte";
  import Separator from "../Separator.svelte";

  export let toggleAll = () => {};

  export let allSelected = false;
  export let partial = false;
</script>

<ListItem
  onclick={toggleAll}
  bind:selected={allSelected}
  {partial}
  showCheckbox
  toggleOption
>
  {allSelected ? "Deselect All" : "Select All"}
</ListItem>
<Separator />
